import { cloneDeep, isEmpty } from 'lodash';
import StoreInfoAction from '@/actions/storeInfo/storeInfoAction';
import OrderServeType from '@/constants/OrderServeType';

const checkServeTypeValid = async (webStoreVo, serveType) => {
  const storeInfoRes = await StoreInfoAction.getStoreInfo(webStoreVo.uuid, '');

  const newStoreVo = cloneDeep(storeInfoRes.data.webStoreVo);

  const { dineInEnable, takeoutEnable, isDeliveryEnable } = newStoreVo || {};

  let isValid = false;


  if (String(serveType) === OrderServeType.DINE_IN && dineInEnable) {
    isValid = true;
  } else if (String(serveType) === OrderServeType.TAKE_OUT && takeoutEnable) {
    isValid = true;
  } else if (String(serveType) === OrderServeType.DELIVERY && isDeliveryEnable) {
    isValid = true;
  } else if (
    String(serveType) !== OrderServeType.DINE_IN &&
    String(serveType) !== OrderServeType.TAKE_OUT &&
    String(serveType) !== OrderServeType.DELIVERY
  ) {
    isValid = true;
  }

  return isValid;
};

export default checkServeTypeValid;
